// Client Knowledge: the routes and the sidebar rows of `wealth.crm.client-knowledge` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.crm.client-knowledge',
    routes: [
        {
            frontend: 'desk',
            path: 'client-knowledge',
            lazy: () => import('@/pages/desk/client-knowledge/page'),
        },
    ],
    nav: [
        {
            frontend: 'desk',
            key: 'client-knowledge',
            label: 'Client Knowledge',
            href: '/desk/client-knowledge',
            icon: 'BookOpen',
            group: 'septima-crm',
            order: 250,
        },
    ],
});
